import { extractGraphQLErrorCode } from "@/lib/extract-graphql-error-code";

const CONFLICT_CODE = "CONFLICT";

export function isActiveRegisterConflict(error: unknown): boolean {
  return extractGraphQLErrorCode(error) === CONFLICT_CODE;
}
